import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from '../components/dialogs/image-dialog.component';
import { InfoDialogComponent } from '../components/dialogs/info-dialog.component';
import { SpinnerService } from '../components/spinner/spinner.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AppMessageService {
	constructor(private _snackBar: MatSnackBar, private _dialog: MatDialog, private spinner: SpinnerService) {}

	getSpinner() {
		return this.spinner;
	}

	showToast(message: string) {
		this._snackBar.open(message, '', {
			duration: 3000,
		});
	}

	showToastSuccess(message: string) {
		this._snackBar.open(message, '', {
			duration: 3000,
			panelClass: ['snackbar-green'],
		});
	}

	showToastError(message: string) {
		this._snackBar.open(message, '', {
			duration: 3000,
			panelClass: ['snackbar-red'],
		});
	}

	public openDialog(component: any, options: object) {
		return firstValueFrom(this._dialog.open(component, options).afterClosed());
	}

	showImageDialog(content: string) {
		this.showImagesDialog(content);
	}

	showImagesDialog(images: any) {
		this._dialog.open(ImageDialogComponent, {
			width: '100%',
			maxWidth: '1400px',
			height: 'auto',
			hasBackdrop: true,
			maxHeight: '1400px',
			// panelClass : ‘personal-details-dialog‘,
			data: {
				images: images,
			},
		});
	}

	showInfoDialog(info: string, title: string = '') {
		this._dialog.open(InfoDialogComponent, {
			width: '80%',
			maxWidth: '800px',
			height: 'auto',
			hasBackdrop: true,
			maxHeight: '400px',
			// panelClass : ‘personal-details-dialog‘,
			data: {
				info,
				title,
			},
		});
	}

	/*
  showConfirm(config: Confirmation): Promise<boolean> {
    config = config as Confirmation;
    return new Promise((resolve, reject) => {
      this.confirmationService.confirm(Object.assign(config, {
          header: this.translate.instant("dialog.confirm"),
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            resolve(true);
          },
          reject: () => {
            resolve(false);
          }
        }
      ));
    });
  }

  showConfirmSync(config: Confirmation)  {
    config.header = this.translate.instant("dialog.confirm");
    config.icon = "pi pi-exclamation-triangle";
    return this.confirmationService.confirm(config);
  }
  */
}
